import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
export const useFormWithSchema = (options, schema) => {
    // @ts-expect-error
    return useForm({ ...options, resolver: zodResolver(schema) });
};
